import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROCESS_STEPS } from "@/data/content";
import Seo from "@/lib/Seo";

export default function Process() {
  return (
    <div>
      <Seo
        path="/process"
        title="Our Process — From First Call to Funded"
        description="Four steps, no theatre. One application, 75+ lenders shopped, real offers side by side, funded in as little as 24 hours."
      />
      <section className="pt-40 pb-24 border-b border-black/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="overline">Process · four movements</div>
          <h1 className="mt-6 font-serif text-6xl md:text-8xl leading-[0.92]">
            From <em className="italic text-[color:var(--gold)]">first call</em> to funded.
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 space-y-24 md:space-y-36">
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
              className="grid grid-cols-12 gap-8 items-center"
            >
              <div className="col-span-12 md:col-span-5">
                <div className="chapter-num select-none">{step.num}</div>
              </div>
              <div className="col-span-12 md:col-span-7 border-l border-black/10 pl-8 md:pl-12">
                <div className="overline">Chapter {step.num}</div>
                <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[1] text-[color:var(--bone)]">
                  {step.title}
                </h2>
                <p className="mt-6 text-[color:var(--bone)]/75 text-lg leading-relaxed max-w-xl">
                  {step.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="border-t border-black/10 py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
          <h3 className="font-serif text-4xl md:text-5xl max-w-xl leading-tight">
            Ready to start? It takes four minutes.
          </h3>
          <Link to="/apply" className="inline-flex items-center gap-3 bg-[color:var(--gold)] text-black px-8 py-4 font-mono text-xs tracking-[0.24em] uppercase hover:bg-[color:var(--gold-strong)] transition-colors">
            Begin application <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
}
